import { render, staticRenderFns } from "./GroupPollsChart.vue?vue&type=template&id=c15e9c94&"
import script from "./GroupPollsChart.vue?vue&type=script&lang=js&"
export * from "./GroupPollsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports